export function formatAmount(
  value: number,
  currency = 'XAF',
  format = 'fr-FR',
): string {
  return new Intl.NumberFormat(format, { style: 'currency', currency }).format(
    value,
  );
}

export const formatLargeNumber = (number: number, locale: string) => {
  return new Intl.NumberFormat(locale === 'fr' ? 'fr-FR' : 'en-US', {
    notation: 'compact',
    compactDisplay: 'short',
  }).format(number);
};

// Function to get max number in array of objects
export const getMaxValue = (data: any[]) => {
  const reduceData = data
    .reduce((acc, item) => {
      return [...acc, ...Object.values(item)];
    }, [])
    .filter((item: any) => typeof item === 'number');

  return Math.max(...reduceData);
};

//Function to get max number of sum of property in array of objects
/*
for example we have array of objects like this
[
  {a: 1, b: 2, c: 3},
  {a: 1, b: 3, c: 5},
  {a: 1, b: 4, c: 6},
  ]
  The function will return 11

 */
export const getMaxValueOfSum = (data: any[]) => {
  const reduceData = data.reduce((acc, item) => {
    return [
      ...acc,
      Object.values(item).reduce((acc: number, item: unknown) => {
        if (typeof item === 'number') return acc + item;
        return acc;
      }, 0),
    ];
  }, []);

  return Math.max(...reduceData);
};

//Transform for example 25489398 to 25000000
export const ceilNumberToTwoDigit = (value: number) => {
  const formattedDataMax = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
  }).format(value);

  // formated datamax to number
  let numberDataMax = Number(formattedDataMax.replace(/[^0-9.-]+/g, ''));
  numberDataMax = Math.ceil(numberDataMax / 5) * 5;
  // complete number of digit of numberDataMax to equal dataMax
  numberDataMax =
    numberDataMax *
    Math.pow(10, value.toString().length - numberDataMax.toString().length);
  return numberDataMax;
};
/**
 * Validates a value based on its type.
 * @param {string | number | readonly string[]} value - The value to validate.
 * @returns {boolean} - Returns true if valid, false otherwise.
 */
export const isValidValue = (
  value: string | number | readonly string[],
): boolean => {
  if (Array.isArray(value)) {
    // Validate array
    return value.length > 0; // Ensure array has at least one element
  }

  if (typeof value === 'string') {
    // Check if the string can be parsed as a valid number
    const numericValue = Number(value);
    if (!isNaN(numericValue)) {
      return numericValue > 0; // Validate as a number if parsable
    }
    return value.trim().length > 0; // Validate as a non-empty string otherwise
  }

  if (typeof value === 'number') {
    // Validate number
    return value > 0;
  }

  return false; // Fallback for unsupported types
};
